import { GET_TTFB_ACTIVE_PRODUCT_REQUEST,
    GET_TTFB_ACTIVE_PRODUCT_SUCCESS,
    GET_TTFB_ACTIVE_PRODUCT_FAILURE,
    RESET_TTFB_ACTIVE_PRODUCT } from '../../actions/business/constants';

const INITIAL_STATE = {
    fetching: false,
    data: null,
    error: false,
    page: 1
}
export default function activeProducts(state = INITIAL_STATE, action) {
    switch(action.type) {
        case GET_TTFB_ACTIVE_PRODUCT_REQUEST:
            return {
                ...state,
                fetching: true
            }
        case GET_TTFB_ACTIVE_PRODUCT_SUCCESS:
            return {
                ...state,
                data: state.page === 1
                    ? action.payload
                    : {
                        ...state.data,
                        data: [...state.data.data,
                            ...action.payload.data]
                    },
                fetching: false,
                hasFetched: true,
                hasEnd: (!action.payload.data.length
                    || (!!action.payload.data.length
                        && action.payload.data.length < 20)),
                page: state.page + 1
            }
        case GET_TTFB_ACTIVE_PRODUCT_FAILURE:
            return {
                ...state,
                ...(!action.error.__CANCEL__ && {
                    error: true,
                    errorMsg: action.error
                }),
                fetching: false
            }
        case RESET_TTFB_ACTIVE_PRODUCT:
            return INITIAL_STATE
        default:
            return state;
    }
}